export const noop =
  (returnValue: any = undefined) =>
  () =>
    returnValue;

export const noopPromise = (resolveValue: any = undefined) =>
  Promise.resolve(resolveValue);
